require('intersection-observer');
import React, { useEffect, useState } from 'react';
import { forEach, indexOf, isEmpty, map, reduce, trim } from 'lodash';
import translateService from '../../../common/translateService';
import {
    scrollToSection,
    openDetails,
} from '../../../services/product/productInteraction';
import ProductDescription from './ProductDescription.jsx';
import ProductReviews from '../reviews/ProductReviews.jsx';
import ReviewStars from '../reviews/ReviewStars.jsx';
import ProductQuestionsAndAnswers from '../questionAndAnswers/ProductQuestionsAndAnswers.jsx';
import './ProductTabs.scss';

const ProductTabs = (props) => {
    let i = 0,
        j = 0;

    const [tabsIntersection, setTabsIntersection] = useState([]);
    const [isObserving, setObserving] = useState(false);
    const tabs = document.querySelectorAll('.prd-tab');

    useEffect(() => {
        // console.log('tabs.length', tabs.length);
        // console.log('props.tabsNumber', props.tabsNumber);
        // console.log('isObserving', isObserving);
        if (
            !props.isMobile &&
            tabs.length === props.tabsNumber &&
            !isObserving
        ) {
            // console.log('observing...');
            observePrdTabs();
            setObserving(true);
        }
    });

    const updateIntersection = (entries, observer) => {
        const items = document.querySelectorAll('.prd-tabs-menu-item');

        setTabsIntersection((prevState) => {
            const tabElements = prevState;
            forEach(entries, (entry) => {
                tabElements[Number(entry.target.dataset.index)] =
                    entry.intersectionRatio;
            });

            const indexMaxIntersecting = indexOf(
                tabElements,
                getMax(tabElements)
            );

            forEach(items, (item, idx) => {
                if (idx === indexMaxIntersecting) {
                    item.classList.add('selected');
                } else {
                    item.classList.remove('selected');
                }
            });

            return tabElements;
        });
    };

    const getMax = (array) => {
        return reduce(array, (prev, curr) => Math.max(prev, curr), 0);
    };

    const handleScroll = (e) => {
        scrollToSection(e);
    };

    const handleOpen = (e) => {
        openDetails(e, props.isMobile);
    };

    const observePrdTabs = () => {
        const tabsObserver = new IntersectionObserver(updateIntersection, {
            threshold: [0, 0.25, 0.5, 0.75, 1],
        });

        const elementsToWatch = document.querySelectorAll('.prd-tab');
        const tabElements = [];

        forEach(elementsToWatch, (el, idx) => {
            tabsObserver.observe(el);
            tabElements[idx] = 0;
        });

        setTabsIntersection(tabElements);
    };

    const techspecs = map(props.techSpecs, (t, i) => {
        const attribute = map(t.attributes, (a, j) => {
            const specs = map(a.specs, (spec, key) => {
                return (
                    <div
                        className={trim(
                            `prd-tab-techspecs-table-row ${
                                spec.indent ? 'indent' : ''
                            }`
                        )}
                        key={key}>
                        <div>{key}</div>
                        <div>{spec.value}</div>
                    </div>
                );
            });

            return (
                <div className='prd-tab-techspecs-spec' key={j}>
                    <div
                        className='prd-tab-techspecs-table-title'
                        dangerouslySetInnerHTML={{
                            __html: a.value,
                        }}
                    />
                    <div className='prd-tab-techspecs-table'>{specs}</div>
                </div>
            );
        });

        return (
            <div className='prd-tab-techspecs-container' key={i}>
                <h2 className='prd-tab-techspecs-title'>{t.productName}</h2>
                {attribute}
            </div>
        );
    });

    return (
        <>
            {!props.isMobile && (
                <div className='prd-tabs-menu'>
                    <h3
                        className='prd-tabs-menu-item'
                        data-index={i++}
                        onClick={handleScroll}>
                        {translateService.get(`productDetail.tabs.description`)}
                    </h3>
                    {!isEmpty(props.techSpecs) && (
                        <h3
                            className='prd-tabs-menu-item'
                            data-index={i++}
                            onClick={handleScroll}>
                            {translateService.get(
                                `productDetail.tabs.techSpecs`
                            )}
                        </h3>
                    )}
                    {props.technologies && (
                        <h3
                            className='prd-tabs-menu-item'
                            data-index={i++}
                            onClick={handleScroll}>
                            {translateService.get(
                                `productDetail.tabs.technologies`
                            )}
                        </h3>
                    )}
                    {props.brandsGuides && (
                        <h3
                            className='prd-tabs-menu-item'
                            data-index={i++}
                            onClick={handleScroll}>
                            {translateService.get(
                                `productDetail.tabs.brandsGuides`
                            )}
                        </h3>
                    )}
                    <h3
                        className='prd-tabs-menu-item'
                        data-index={i++}
                        onClick={handleScroll}>
                        {`${translateService.get(
                            `productDetail.tabs.reviews`
                        )} (${props.revNumber})`}
                    </h3>
                    <h3
                        className='prd-tabs-menu-item'
                        data-index={i++}
                        onClick={handleScroll}>
                        {`${translateService.get(
                            `productDetail.tabs.qAndA`
                        )} (${props.qandaNumber})`}
                    </h3>
                    {props.enableNews && (
                        <h3
                            className='prd-tabs-menu-item topnews'
                            data-index={i++}
                            onClick={handleScroll}>
                            {translateService.get(`productDetail.tabs.top`)}{' '}
                            <span className='highlight'>
                                {translateService.get(
                                    `productDetail.tabs.news`
                                )}
                            </span>
                        </h3>
                    )}
                </div>
            )}

            <div className='prd-tabs'>
                <div className='prd-tab prd-tab-description' data-index={j++}>
                    <div className='prd-tab-name' onClick={handleOpen}>
                        <h1 className='selected'>
                            {translateService.get(
                                `productDetail.tabs.description`
                            )}
                        </h1>
                        {props.isMobile && <h1 className='prd-tab-icon'>+</h1>}
                    </div>
                    <div className='prd-tab-content'>
                        <ProductDescription
                            description={props.description}
                            descriptionAutomated={props.descriptionAutomated}
                            descriptionOriginalUrl={
                                props.descriptionOriginalUrl
                            }
                        />
                    </div>
                </div>
                {!isEmpty(props.techSpecs) && (
                    <div className='prd-tab prd-tab-techspecs' data-index={j++}>
                        <div className='prd-tab-name' onClick={handleOpen}>
                            <h1>
                                {translateService.get(
                                    `productDetail.tabs.techSpecs`
                                )}
                            </h1>
                            <h1 className='prd-tab-icon desktop'>+</h1>
                        </div>
                        <div className='prd-tab-content'>{techspecs}</div>
                    </div>
                )}
                {props.technologies && (
                    <div
                        className='prd-tab prd-tab-technology'
                        data-index={j++}>
                        <div className='prd-tab-name' onClick={handleOpen}>
                            <h1>
                                {translateService.get(
                                    `productDetail.tabs.technologies`
                                )}
                            </h1>
                            {props.isMobile && (
                                <h1 className='prd-tab-icon'>+</h1>
                            )}
                        </div>
                        <div className='prd-tab-content'></div>
                    </div>
                )}
                {props.brandsGuides && (
                    <div
                        className='prd-tab prd-tab-sizeguide'
                        data-index={j++}
                        ref={props.sizeChartRef}>
                        <div className='prd-tab-name' onClick={handleOpen}>
                            <h1>
                                {translateService.get(
                                    `productDetail.tabs.brandsGuides`
                                )}
                            </h1>
                            {props.isMobile && (
                                <h1 className='prd-tab-icon'>+</h1>
                            )}
                        </div>
                        <div
                            className='prd-tab-content'
                            dangerouslySetInnerHTML={{
                                __html: props.brandsGuides,
                            }}
                        />
                    </div>
                )}
                <div
                    className='prd-tab prd-tab-reviews'
                    data-index={j++}
                    ref={props.reviewsRef}>
                    <div className='prd-tab-name' onClick={handleOpen}>
                        <h1>
                            {!props.isMobile
                                ? translateService.get(
                                      `productDetail.tabs.reviews`
                                  )
                                : `${translateService.get(
                                      `productDetail.tabs.reviews`
                                  )} (${props.revNumber})`}
                        </h1>
                        {!props.isMobile && props.revNumber !== 0 ? (
                            <h1 className='prd-tab-stars'>
                                <span className='prd-tab-stars-average'>
                                    {props.revAverage}
                                </span>
                                <span className='prd-tab-stars-max'>/5</span>
                                <ReviewStars
                                    maxRating={5}
                                    average={props.revAverage}
                                />
                            </h1>
                        ) : (
                            <></>
                        )}
                        {props.isMobile && <h1 className='prd-tab-icon'>+</h1>}
                    </div>
                    <div className='prd-tab-content prd-reviews-container'>
                        {props.isMobile && props.revNumber !== 0 ? (
                            <h1 className='prd-tab-stars'>
                                <span className='prd-tab-stars-average'>
                                    {props.revAverage}
                                </span>
                                <span className='prd-tab-stars-max'>/5</span>
                                <ReviewStars
                                    maxRating={5}
                                    average={props.revAverage}
                                />
                            </h1>
                        ) : (
                            <></>
                        )}
                        <ProductReviews
                            slug={props.slug}
                            isMobile={props.isMobile}
                            isAuthenticated={props.userAuthenticated}
                        />
                    </div>
                </div>
                <div className='prd-tab prd-tab-qanda' data-index={j++}>
                    <div className='prd-tab-name' onClick={handleOpen}>
                        <h1>
                            {!props.isMobile
                                ? translateService.get(
                                      `productDetail.tabs.qAndA`
                                  )
                                : `${translateService.get(
                                      `productDetail.tabs.qAndA`
                                  )} (${props.qandaNumber})`}
                        </h1>
                        {props.isMobile && <h1 className='prd-tab-icon'>+</h1>}
                    </div>
                    <div className='prd-tab-content prd-questions-container'>
                        <ProductQuestionsAndAnswers
                            slug={props.slug}
                            isMobile={props.isMobile}
                            isAuthenticated={props.userAuthenticated}
                        />
                    </div>
                </div>
                {props.enableNews && (
                    <div className='prd-tab prd-tab-topnews' data-index={j++}>
                        <div className='prd-tab-name' onClick={handleOpen}>
                            <h1>
                                {translateService.get(`productDetail.tabs.top`)}{' '}
                                <span className='highlight'>
                                    {translateService.get(
                                        `productDetail.tabs.news`
                                    )}
                                </span>
                            </h1>
                            {props.isMobile && (
                                <h1 className='prd-tab-icon'>+</h1>
                            )}
                        </div>
                        <div className='prd-tab-content'></div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductTabs;
